import { User } from "@/CodegenTypes";


export const canSeeTtPopl = (user?: User | null) => {
    return (user?.ttD1PlaceoutPl || 0) > 0 || (user?.ttD2PlaceoutPl || 0) > 0 
        || (user?.ttD3PlaceoutPl || 0) > 0 || (user?.ttD4PlaceoutPl || 0) > 0;
}